import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsRoutingModule } from './forms-routing.module';
import { FormsFormModule } from './forms-form/forms-form.module';

import { FormsGlobals } from '../../models/forms/forms.enum';
import { FormsComponent } from './forms.component';
import { FormsService } from './forms.service';
import { FormsSummaryModule } from './forms-summary/forms-summary.module';

// material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsBuilderModule } from './forms-builder/forms-builder.module';
import { FormsBuilderPolishedModule } from './forms-builder-polished/forms-builder-polished.module';
import {MatTabsModule} from '@angular/material/tabs';
import {FormsParagraphModule} from './forms-paragraph/forms-paragraph.module';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {FormsItemModule} from './forms-item/forms-item.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { FormsFullSizeImageDialogComponent } from './dialogs/forms-full-size-image-dialog/forms-full-size-image-dialog.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DiagnosisComponent } from './custom/diagnosis/diagnosis.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {DirectivesModule} from '../../directives/directives.module';
import { DiagnosisEcirDialogComponent } from './custom/diagnosis/dialogs/diagnosis-ecir-dialog/diagnosis-ecir-dialog.component';
import { DiagnosisTriDialogComponent } from './custom/diagnosis/dialogs/diagnosis-tri-dialog/diagnosis-tri-dialog.component';
import {DiagnosisLymphadenopathyDialogComponent} from './custom/diagnosis/dialogs/diagnosis-lymphadenopathy-dialog/diagnosis-lymphadenopathy-dialog.component';
import { DiagnosisSoftTissueDialogComponent } from './custom/diagnosis/dialogs/diagnosis-soft-tissue-dialog/diagnosis-soft-tissue-dialog.component';
import { DiagnosisPriorQaDialogComponent } from './custom/diagnosis/dialogs/diagnosis-prior-qa-dialog/diagnosis-prior-qa-dialog.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DiagnosisCloneDialogComponent } from './custom/diagnosis/dialogs/diagnosis-clone-dialog/diagnosis-clone-dialog.component';
import { RecallV2Component } from './custom/recall-v2/recall-v2.component';
import { FormViewerComponent } from './form-viewer/form-viewer.component';
import { LucideIconsModule } from '../../shared/lucide-icons.module';

@NgModule({
  declarations: [
    FormsComponent,
    FormsFullSizeImageDialogComponent,
    DiagnosisComponent,
    DiagnosisEcirDialogComponent,
    DiagnosisTriDialogComponent,
    DiagnosisLymphadenopathyDialogComponent,
    DiagnosisSoftTissueDialogComponent,
    DiagnosisPriorQaDialogComponent,
    DiagnosisCloneDialogComponent,
    RecallV2Component,
    FormViewerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    FormsRoutingModule,
    FormsFormModule,
    FormsFormModule,
    FormsBuilderModule,
    FormsBuilderPolishedModule,
    FormsSummaryModule,
    //TdoSharedModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTabsModule,
    FormsParagraphModule,
    TdoControlsModule,
    FormsItemModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
        LucideIconsModule,
    MatInputModule,
    DirectivesModule,
    MatTooltipModule,
  ],
    exports: [
      FormsComponent,
        DiagnosisComponent,
        RecallV2Component,
    ],
  providers: [
    FormsService,
    FormsGlobals
  ]
})
export class FormsTDOModule { }
